import { Chip, TableCell, Tooltip } from '@mui/material';
import { Information } from '@opengov/react-capital-assets';
import moment from 'moment';
import React from 'react';
import { FragmentType, getFragmentData, graphql } from '../../../../gql-generated/hasura';
import { SpreadsheetsProcessingStatus_Enum } from '../../../../gql-generated/hasura/graphql';
import { getCompletedLocaleText } from '../../../../locale/utils';
import locale from './customReports-locale.json';
import { styles } from './CustomReportsTableStatusCell.styles';
import { TableCellSpinner } from './TableCellSpinner';

export const CustomReportsTableStatusCell_CustomReportFragment = graphql(`
  fragment CustomReportsTableStatusCell_CustomReportFragment on spreadsheets {
    id
    processingStatus
    processingErrors
    updatedAt
  }
`);

type Props = {
  customReport: FragmentType<typeof CustomReportsTableStatusCell_CustomReportFragment>;
};

export function CustomReportsTableStatusCell({ customReport: customReportFragment }: Props) {
  const customReport = getFragmentData(CustomReportsTableStatusCell_CustomReportFragment, customReportFragment);
  const status = customReport.processingStatus;
  const processingErrors = customReport.processingErrors;

  switch (status) {
    case SpreadsheetsProcessingStatus_Enum.Completed:
      return (
        <TableCell sx={styles.statusCell} data-test="custom-reports-table-status-cell">
          {getCompletedLocaleText(locale.statusCell.updated, {
            updatedAt: moment.utc(customReport.updatedAt).fromNow()
          })}
        </TableCell>
      );

    case SpreadsheetsProcessingStatus_Enum.Processing:
    case SpreadsheetsProcessingStatus_Enum.Uploaded:
      return (
        <TableCell sx={styles.statusCell} data-test="custom-reports-table-status-cell">
          <TableCellSpinner />
        </TableCell>
      );

    case SpreadsheetsProcessingStatus_Enum.Failed:
      return (
        <TableCell sx={styles.statusCell} data-test="custom-reports-table-status-cell">
          <Tooltip
            title={
              processingErrors && processingErrors.length > 0
                ? processingErrors[0]
                : locale.statusCell.processingErrorFallback
            }
            placement="top"
          >
            <Chip
              label={locale.statusCell.uploadError}
              color="error"
              size="small"
              variant="filled"
              sx={styles.errorChip}
              icon={<Information />}
            />
          </Tooltip>
        </TableCell>
      );

    default:
      return null;
  }
}
